import { Product } from '../types/product';

export const products: Product[] = [
  {
    id: '1',
    name: 'Nail Box Thiết Kế Móng Úp, Móng Giả Giáng Sinh Noel Mắt Mèo Fench Đỏ Rịu Sang Chảnh',
    code: 'M07',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-mong-up-mong-gia-giang-sinh-noel-mat-meo-fench-do-riu-sang-chanh-m07-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả thiết kế đặc biệt cho mùa Giáng Sinh với họa tiết mắt mèo và fench đỏ rịu sang trọng. Sản phẩm được làm từ chất liệu cao cấp, bền đẹp, dễ dàng gắn và tháo. Phù hợp cho các dịp lễ hội, tiệc tùng hay những ngày đặc biệt. Thiết kế độc đáo, tạo điểm nhấn nổi bật cho bàn tay của bạn.'
  },
  {
    id: '2',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Giả Vàng Nhạt Chấm Bi Hottrend',
    code: 'M30',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-gia-vang-nhat-cham-bi-hottrend-m30-100k.jpg',
    isSale: true,
    description: 'Móng giả thiết kế hiện đại với tông màu vàng nhạt kết hợp chấm bi hottrend. Sản phẩm phù hợp với mọi phong cách thời trang, từ thanh lịch đến năng động. Chất liệu an toàn, không gây kích ứng, dễ dàng sử dụng và bảo quản.'
  },
  {
    id: '3',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Hồng Fench Hồng Sữa Mắt Mèo Ánh Trăng',
    code: 'P22',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-hong-fench-hong-sua-mat-meo-anh-trang-p22-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả với thiết kế thạch hồng kết hợp fench hồng sữa và họa tiết mắt mèo ánh trăng độc đáo. Màu sắc nhẹ nhàng, nữ tính, phù hợp cho mọi dịp. Chất liệu cao cấp, độ bền cao, dễ dàng gắn và tháo mà không làm hỏng móng thật.'
  },
  {
    id: '4',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Ombre Thạch Hồng Nude Và Trắng Gạo',
    code: 'P19',
    price: 60000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-ombre-thach-hong-nude-va-trang-gao-p19-60k.jpg',
    description: 'Móng giả với hiệu ứng ombre đẹp mắt, chuyển từ thạch hồng nude sang trắng gạo một cách tự nhiên. Thiết kế tinh tế, thanh lịch, phù hợp cho công sở và các dịp quan trọng. Giá cả hợp lý, chất lượng đảm bảo.'
  },
  {
    id: '5',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Hồng Nude Fench Tráng Gương Sang Trọng',
    code: 'P21',
    price: 60000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-hong-nude-fench-trang-guong-sang-trong-p21-60k.jpg',
    description: 'Bộ móng giả với thiết kế thạch hồng nude kết hợp fench tráng gương tạo vẻ ngoài sang trọng, quý phái. Màu sắc nhẹ nhàng, dễ phối đồ, phù hợp cho mọi lứa tuổi. Chất liệu an toàn, không độc hại.'
  },
  {
    id: '6',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Nâu Nude Tráng Gương Vàng Sang Chảnh',
    code: 'P29',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-nau-nude-trang-guong-vang-sang-chanh-p29-100k.jpg',
    isSale: true,
    description: 'Móng giả với thiết kế thạch nâu nude kết hợp tráng gương vàng tạo vẻ ngoài sang chảnh, đẳng cấp. Màu sắc ấm áp, phù hợp cho mùa thu đông. Thiết kế tinh tế, chất lượng cao cấp.'
  },
  {
    id: '7',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Giả Fench Phối Sao Cá Tính Siêu Slay',
    code: 'M14',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-gia-fench-phoi-sao-ca-tinh-sieu-slay-m14-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả với thiết kế fench phối sao độc đáo, cá tính và siêu slay. Phù hợp cho những cô nàng yêu thích phong cách nổi bật, tự tin. Thiết kế hiện đại, chất lượng tốt, dễ dàng mix match với nhiều trang phục khác nhau.'
  },
  {
    id: '8',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Gạo Fench Tráng Gương Đính Đá Sang Chảnh',
    code: 'P26',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-gao-fench-trang-guong-dinh-da-sang-chanh-p26-100k.jpg',
    isSale: true,
    description: 'Móng giả cao cấp với thiết kế thạch gạo kết hợp fench tráng gương và đính đá lấp lánh. Vẻ ngoài sang chảnh, quý phái, phù hợp cho các dịp đặc biệt như tiệc tùng, sự kiện. Chất liệu cao cấp, độ bền cao.'
  },
  {
    id: '9',
    name: 'Nail Box Thiết Kế Móng Úp, Móng Giả Giáng Sinh Noel Siêu Sang Chảnh Dễ Thương',
    code: 'M24',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-mong-up-mong-gia-giang-sinh-noel-sieu-sang-chanh-de-thuong-m24-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả thiết kế đặc biệt cho mùa Giáng Sinh với vẻ ngoài siêu sang chảnh và dễ thương. Thiết kế độc đáo, phù hợp cho các dịp lễ hội cuối năm. Chất liệu an toàn, dễ sử dụng, tạo điểm nhấn nổi bật cho bàn tay.'
  },
  {
    id: '10',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Gạo Fench Trắng Mắt Mèo Ánh Trăng Xoay Tròn',
    code: 'P28',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-gao-fench-trang-mat-meo-anh-trang-xoay-tron-p28-100k.jpg',
    isSale: true,
    description: 'Móng giả với thiết kế thạch gạo kết hợp fench trắng và họa tiết mắt mèo ánh trăng xoay tròn độc đáo. Thiết kế tinh tế, hiện đại, phù hợp cho mọi dịp. Màu sắc nhẹ nhàng, dễ phối đồ.'
  },
  {
    id: '11',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Trơn Tráng Gương Ngọc Trai Sang Chảnh',
    code: 'P18',
    price: 60000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-tron-trang-guong-ngoc-trai-sang-chanh-p18-60k.jpg',
    description: 'Bộ móng giả thiết kế trơn với lớp tráng gương ngọc trai tạo vẻ ngoài sang chảnh, thanh lịch. Thiết kế đơn giản nhưng tinh tế, phù hợp cho công sở và các dịp quan trọng. Giá cả hợp lý, chất lượng tốt.'
  },
  {
    id: '12',
    name: 'Nail Box Thiết Kế Móng Úp, Móng Giả Tráng Gương Fench Trắng Sang Chảnh',
    code: 'M06',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-mong-up-mong-gia-trang-guong-fench-trang-sang-chanh-m06-100k.jpg',
    isSale: true,
    description: 'Móng giả với thiết kế tráng gương fench trắng tạo vẻ ngoài sang chảnh, quý phái. Màu sắc tinh khiết, dễ phối đồ, phù hợp cho mọi dịp. Chất liệu cao cấp, độ bền cao, dễ dàng sử dụng.'
  },
  {
    id: '13',
    name: 'Nail Box Thiết Kế 10 Móng Úp Charm Nơ HotHit Vẽ Nổi Tráng Gương',
    code: 'M77',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-10-mong-up-charm-no-hothit-ve-noi-trang-guong-m77-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả đầy đủ 10 móng với thiết kế charm nơ hottrend và vẽ nổi tráng gương độc đáo. Thiết kế hiện đại, nổi bật, phù hợp cho những cô nàng yêu thích phong cách trẻ trung, năng động. Chất lượng tốt, dễ sử dụng.'
  },
  {
    id: '14',
    name: 'Nail Box Thiết Kế, Móng Up Mắt Mèo Kim Cương Thạch Dây Bi',
    code: 'M39',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-mong-up-mat-meo-kim-cuong-thach-day-bi-m39-100k.jpg',
    isSale: true,
    description: 'Móng giả với thiết kế mắt mèo kim cương kết hợp thạch và dây bi lấp lánh. Vẻ ngoài sang trọng, quý phái, phù hợp cho các dịp đặc biệt. Thiết kế độc đáo, chất lượng cao cấp, tạo điểm nhấn nổi bật.'
  },
  {
    id: '15',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Giả Chấm Bi Phối Đen Trắng Fench Hottrend',
    code: 'M09',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-gia-cham-bi-phoi-den-trang-fench-hottrend-m09-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả với thiết kế chấm bi phối đen trắng fench hottrend, phong cách hiện đại và năng động. Màu sắc tương phản tạo điểm nhấn, phù hợp cho mọi phong cách thời trang. Chất lượng tốt, giá cả hợp lý.'
  },
  {
    id: '16',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Nude Mắt Mèo Ánh Trăng Phối Nhũ Ngọc Fench Đầu Móng Sang Chảnh',
    code: 'P33',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-nude-mat-meo-anh-trang-phoi-nhu-ngoc-fench-dau-mong-sang-chanh-p33-100k.jpg',
    isSale: true,
    description: 'Móng giả cao cấp với thiết kế thạch nude kết hợp mắt mèo ánh trăng và nhũ ngọc fench ở đầu móng. Vẻ ngoài sang chảnh, tinh tế, phù hợp cho các dịp đặc biệt. Thiết kế độc đáo, chất lượng cao cấp.'
  },
  {
    id: '17',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Trong Fench Gạo Đính Đá Tráng Gương Sang Trọng',
    code: 'P23',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-trong-fench-gao-dinh-da-trang-guong-sang-trong-p23-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả với thiết kế thạch trong kết hợp fench gạo, đính đá và tráng gương tạo vẻ ngoài sang trọng, quý phái. Thiết kế tinh tế, chất lượng cao cấp, phù hợp cho các dịp đặc biệt như tiệc tùng, sự kiện.'
  },
  {
    id: '18',
    name: 'Nail Box Thiết Kế Trơn Thạch Đỏ Rịu Sang Trọng',
    code: 'M104',
    price: 100000,
    image: '/product-img/nail-box-thiet-ke-tron-thach-do-riu-sang-trong-m104-100k.jpg',
    isSale: true,
    description: 'Móng giả với thiết kế trơn thạch đỏ rịu tạo vẻ ngoài sang trọng, quyến rũ. Màu sắc ấm áp, nổi bật, phù hợp cho mọi dịp. Thiết kế đơn giản nhưng tinh tế, chất lượng tốt, dễ dàng sử dụng.'
  },
  {
    id: '19',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Thạch Hồng Nude Fench Chấm Bi Nơ Mini Siêu Dễ Thương',
    code: 'P25',
    price: 100000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-thach-hong-nude-fench-cham-bi-no-mini-sieu-de-thuong-p25-100k.jpg',
    isSale: true,
    description: 'Bộ móng giả với thiết kế thạch hồng nude kết hợp fench, chấm bi và nơ mini tạo vẻ ngoài siêu dễ thương, nữ tính. Phù hợp cho những cô nàng yêu thích phong cách ngọt ngào, đáng yêu. Chất lượng tốt, giá cả hợp lý.'
  },
  {
    id: '20',
    name: 'Nailbox Thiết Kế, Móng Úp, Móng Tay Giả Nâu Phối Đỏ Đô Fench Sang Trọng',
    code: 'P20',
    price: 60000,
    image: '/product-img/nailbox-thiet-ke-mong-up-mong-tay-gia-nau-phoi-do-do-fench-sang-trong-p20-60k.jpg',
    description: 'Móng giả với thiết kế nâu phối đỏ đô fench tạo vẻ ngoài sang trọng, ấm áp. Màu sắc phù hợp cho mùa thu đông, dễ phối đồ. Thiết kế tinh tế, chất lượng tốt, giá cả hợp lý.'
  }
];

